import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Text } from 'components/typography/Text';
import { Image as SemanticImage } from 'semantic-ui-react';
import exerciseSrc from 'assets/media/eden/my-workspace/exercise.jpeg';
import styles from '../styles.module.scss';

export const ExerciseOnEveryFloor = () => (
  <>
    <SemanticImage
      src={exerciseSrc}
      alt="Exercise"
      className={styles.image}
    />

    <Text size={16}>
      <FormattedMessage
        id="exerciseOnEveryFloorDescription"
        values={{
          bold: (...chunks) => (
            <Text
              size={16}
              element="span"
              bold
            >
              {chunks}
            </Text>
          ),
        }}
      />
    </Text>
  </>
);
